'use client'

/**
 * Sidebar Component
 * Navigation sidebar for admin users
 *
 * Features:
 * - Brand header with CC logo
 * - Navigation items for admin sections
 * - User info footer with logout
 * - Mobile responsive with overlay
 */

import React from 'react'

const NAV_ITEMS = [
  { key: 'dashboard', label: 'dashboard', icon: '$' },
  { key: 'users', label: 'usuários', icon: '>' },
  { key: 'logs', label: 'logs', icon: '@' },
  { key: 'usage', label: 'usage', icon: '%' },
  { key: 'plans', label: 'plans', icon: '₿' },
  { key: 'services', label: 'serviços', icon: '&' },
  { key: 'financial', label: 'financeiro', icon: '¤' },
  { key: 'settings', label: 'config', icon: '#' },
]

export default function Sidebar({ user, activeSection, onNavigate, isOpen, onToggle, onLogout }) {
  const handleNavClick = (section) => {
    onNavigate(section)
    // Close sidebar on mobile
    if (window.innerWidth < 769) {
      onToggle()
    }
  }

  return (
    <>
      {/* Overlay backdrop (mobile only) */}
      {isOpen && (
        <div
          className="sc-sidebar-overlay"
          onClick={onToggle}
          aria-hidden="true"
        />
      )}

      {/* Sidebar container */}
      <aside className={`sc-sidebar ${isOpen ? 'sc-sidebar--open' : ''}`}>
        {/* Brand section */}
        <div className="sc-sidebar-brand">
          <div style={{
            width: '32px',
            height: '32px',
            background: 'var(--sc-green-dim)',
            border: '1px solid var(--sc-green-muted)',
            borderRadius: 'var(--radius-base)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'var(--font-display)',
            fontWeight: 700,
            fontSize: '0.875rem',
            color: 'var(--sc-green-bright)',
            textShadow: '0 0 8px rgba(0,255,65,0.4)',
          }}>
            CCM
          </div>
          <span style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 600,
            fontSize: '1rem',
            color: 'var(--sc-text-primary)',
            letterSpacing: '0.05em',
          }}>
            CCMakers Code
          </span>
        </div>

        {/* Nav section */}
        <nav className="sc-sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <button
              key={item.key}
              className={`sc-sidebar-item ${activeSection === item.key ? 'sc-sidebar-item--active' : ''}`}
              onClick={() => handleNavClick(item.key)}
            >
              <span className="sc-sidebar-item-icon">{item.icon}</span>
              {item.label}
            </button>
          ))}
        </nav>

        {/* Footer: user info + logout */}
        <div className="sc-sidebar-footer">
          <div className="sc-sidebar-user">
            <div className="sc-sidebar-user-avatar">
              {user?.username?.charAt(0).toUpperCase() || '?'}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="sc-sidebar-user-name">{user?.username}</div>
              <div className="sc-sidebar-user-tier">{user?.tier}</div>
            </div>
          </div>
          <button
            onClick={onLogout}
            style={{
              width: '100%',
              marginTop: '0.75rem',
              padding: '6px 12px',
              background: 'none',
              border: '1px solid var(--sc-border)',
              borderRadius: 'var(--radius-base)',
              color: 'var(--sc-text-muted)',
              fontFamily: 'var(--font-mono)',
              fontSize: '0.6875rem',
              cursor: 'pointer',
              transition: 'all 0.15s ease',
              textAlign: 'center',
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = 'var(--sc-red-base)'
              e.target.style.color = 'var(--sc-red-bright)'
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = 'var(--sc-border)'
              e.target.style.color = 'var(--sc-text-muted)'
            }}
          >
            $ logout --force
          </button>
        </div>
      </aside>
    </>
  )
}
